export default __webpack_public_path__ + "static/media/your-squad.2bc73959.png";